import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="ribbon-swatch"
// A picked custom shade becomes the swatch the custom option submits, and picks that option.
export default class extends Controller {
  static targets = ["custom", "picker"];

  pick() {
    this.customTarget.value = this.pickerTarget.value;
    this.customTarget.checked = true;
  }
}
